import React from "react";

function AllowedValuesFileUpload({
    file,
    onFileChange,
    existingFileName,
    valueCount = 0,
    error
}) {
    return (
        <div className="col-md-12">
            <div className="mb-3">
                <label htmlFor="allowedValuesFile" className="form-label mb-0">
                    Allowed Values File (.xlsx / .csv)
                    <span className="required_field">*{error}</span>
                </label>
                <input
                    type="file"
                    className="form-control"
                    id="allowedValuesFile"
                    accept=".xlsx,.csv"
                    onChange={(e) => onFileChange(e.target.files?.[0] || null)}
                />
                {existingFileName ? (
                    <div className="max_char mt-1">
                        Current file: {existingFileName}
                        {valueCount > 0 ? ` (${valueCount} values)` : ""}
                    </div>
                ) : null}
                <div className="max_char">Upload one column of allowed values. First row may be a header.</div>
            </div>
        </div>
    );
}

export default AllowedValuesFileUpload;
